class DeviceInfoManager {
    #status_height;
    #naviagtionBar_height
    #device;
    #app_version;

    init(device){
        this.#device = device;
    }

    setAppVersion(app_version){
        this.#app_version = app_version;
    }

    setStatusHeight(status_height){
        this.#status_height = status_height;
    }

    setNavigationBarHeight(naviagtionBar_height){
        this.#naviagtionBar_height = naviagtionBar_height;
    }

    async setStatusBarTextColor(color){
        if(this.#device == 'android'){
            if(this.#app_version > 22) window.Android.setStatusBarTextColor(color);
        } else if(this.#device == 'ios'){
            /*eslint-disable no-undef */
            if(this.#app_version > 32) webkit.messageHandlers.ios.postMessage({cmd : 'setStatusBarTextColor', color : color});
        }
    }

    async getStatusHeight(){
        if(this.#device == 'android'){
            this.#status_height = (window.Android.getStatusBarHeight() / window.devicePixelRatio);
        }else if(this.#device == 'ios') {
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'setStatusHeight'});
            await this.waitMiliSeconds(100);
        }

        return this.#status_height;
        // return 0;
    }

    async getNavigationBarHeight(){
        if(this.#device == 'android'){
            this.#naviagtionBar_height = (window.Android.getNavigationBarHeight() / window.devicePixelRatio);
        }else if(this.#device == 'ios') {
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'setNavigationBarHeight'});
            await this.waitMiliSeconds(100);
        }

        return this.#naviagtionBar_height;
        // return 0;
    }

    async getContacts(){
        if(this.#device === 'android'){
            const result_str = window.Android.getContacts();
            return result_str;
        }else if(this.#device === 'ios') {
            const complete_callback = new Promise((resolve, reject) => {
                reject;

                window.setContactsFromIOS = (result_str) => {
                    resolve(result_str);
                }

                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({cmd : 'getContacts'});
            })

            return await complete_callback;
        }
    }


    waitMiliSeconds(time) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }

}

const deviceInfoManager = new DeviceInfoManager();

export default deviceInfoManager;